module.exports = __webpack_public_path__ + "cd942bda71b2fbefa3957ea414e48b65.svg";